export default "__VITE_ASSET__DrcOauYb__"